// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2xNtF","logo":"index_logo_MWRBE","logoAnimate":"index_logoAnimate_3A5rk","mainLogo":"index_mainLogo_3e1P7","version":"index_version_3ixzS"};